/**
 * appointment list mock data
 * http://mockjs.com/
 */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

// 车辆到店登记
Mock.mock(/car_visit\/workshops/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': [
    { 'workshop_id': '1', 'workshop_name': '支撑车间' },
    { 'workshop_id': '2', 'workshop_name': '精品车间' },
    { 'workshop_id': '3', 'workshop_name': null }
  ]
})

// 车辆到店登记（进店）
Mock.mock(/car_visit\/register/, 'post' + mockSwitch, {
  'code': 0,
  'message': 'ok'
})

// 车辆到店登记（进车间）
Mock.mock(/car_visit\/register\/workshop_visit/, 'post' + mockSwitch, {
  'code': 0,
  'message': 'ok'
})

// 获取客户记录本中的历史记录
Mock.mock(/track_customer\/record/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'total_num': 30,
    'customer_mobile': '18245678901',
    'customer_name': '王先生',
    'booking_car_status': false,
    'traces': [{
      'comment': '朋友推荐朋友推荐朋友推荐朋友推荐朋友推荐朋友推荐朋友推荐朋友推荐朋友推荐朋友推荐朋友推荐朋友推荐朋友推荐朋友推荐朋友推荐朋友推荐',
      'images': [
        'https://test-images-cdn.cheanjia.com/zhongsheng/image/v1/qdiyutildtcvvwadnycjxadsixja.jpg',
        'https://test-images-cdn.cheanjia.com/zhongsheng/image/v1/xtmlihznyxrzaickhkxafwwyygia.jpg'
      ],
      'record_at': '07月24日 15:00'
    }]
  }
})
// 保存客户记录本
Mock.mock(/track_customer\/record/, 'post' + mockSwitch, {
  'code': 0,
  'message': 'ok'
})
// 车辆到店登记
Mock.mock(/track_customer\/list_records/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'total': 50,
    'customer_info|10': [
      {
        'image_url': 'http://img5.imgtn.bdimg.com/it/u=415293130,2419074865&fm=27&gp=0.jpg',
        'plate_number': '粤A12345',
        'name': '李先生',
        'mobile': '1883928393',
        'last_visit_time': '2018-09-21',
        'is_disturb': false
      }
    ]
  }
})

// 获取客户详细信息
Mock.mock(/sales_receptions\/customer\/\d$/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    'customer_info': {
      'customer_mobile': '17685255959',
      'intention_level_id': 1,
      'max_buy_car_budget': 500,
      'min_buy_car_budget': 100,
      'intention_car_model_name': '劳斯莱斯',
      'customer_name': '陈放放',
      'arrival_type_id': 2,
      'is_test_drive': true,
      'is_arrival_notification': true,
      'follow_result': 1
    }
  },
  'message': '获取成功'
})

// 获取客户笔记记录
Mock.mock(/sales_receptions\/1\/notes/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    'notes': [
      {
        'note_type': 1,
        'note': '我是一个笔记，写的还可以的笔记',
        'creator_name': '张三',
        'created_at': '2020-08-31',
        'id': 1,
        'images': [
          'https://dpu-test.lxusercontent.com/park/device/images/10199/btlef0pel8gr1em22csg.jpg',
          'https://dpu-test.lxusercontent.com/park/device/images/10199/btlef0pel8gr1em22csg.jpg'
        ],
        'next_follow_at': '09月02日 13:48',
        'plate_number': '粤S366666',
        'arrive_time': '2020-08-31'
      },
      {
        'note_type': 1,
        'note': '',
        'creator_name': '张三',
        'created_at': '2020-08-31',
        'id': 2,
        'images': [
        ],
        'next_follow_at': '09月02日 13:48',
        'plate_number': '粤S366666',
        'arrive_time': '2020-08-31'
      },
      {
        'note_type': 1,
        'note': '我是一个笔记，写的还可以的笔记',
        'creator_name': '张三',
        'created_at': '2020-08-31',
        'id': 3,
        'images': [
          'https://dpu-test.lxusercontent.com/park/device/images/10199/btlef0pel8gr1em22csg.jpg',
          'https://dpu-test.lxusercontent.com/park/device/images/10199/btlef0pel8gr1em22csg.jpg',
          'https://dpu-test.lxusercontent.com/park/device/images/10199/btlef0pel8gr1em22csg.jpg'
        ],
        'next_follow_at': '09月02日 13:48',
        'plate_number': '粤S366666',
        'arrive_time': '2020-08-31'
      },
      {
        'note_type': 1,
        'note': '',
        'creator_name': '张三',
        'created_at': '2020-08-31',
        'id': 4,
        'images': [
        ],
        'next_follow_at': '09月02日 13:48',
        'plate_number': '粤S366666',
        'arrive_time': '2020-08-31'
      },
      {
        'note_type': 1,
        'note': '我是一个笔记，写的还可以的笔记',
        'creator_name': '张三',
        'created_at': '2020-08-31',
        'id': 5,
        'images': [
        ],
        'next_follow_at': '09月02日 13:48',
        'plate_number': '粤S366666',
        'arrive_time': '2020-08-31'
      },
      {
        'note_type': 1,
        'note': '我是一个笔记，写的还可以的笔记',
        'creator_name': '张三',
        'created_at': '2020-08-31',
        'id': 6,
        'images': [
          'https://dpu-test.lxusercontent.com/park/device/images/10199/btlef0pel8gr1em22csg.jpg',
          'https://dpu-test.lxusercontent.com/park/device/images/10199/btlef0pel8gr1em22csg.jpg',
          'https://dpu-test.lxusercontent.com/park/device/images/10199/btlef0pel8gr1em22csg.jpg'
        ],
        'next_follow_at': '09月02日 13:48',
        'plate_number': '粤S366666',
        'arrive_time': '2020-08-31'
      },
      {
        'note_type': 1,
        'note': '我是一个笔记，写的还可以的笔记',
        'creator_name': '张三',
        'created_at': '2020-08-31',
        'id': 7,
        'images': [
          'https://dpu-test.lxusercontent.com/park/device/images/10199/btlef0pel8gr1em22csg.jpg',
          'https://dpu-test.lxusercontent.com/park/device/images/10199/btlef0pel8gr1em22csg.jpg',
          'https://dpu-test.lxusercontent.com/park/device/images/10199/btlef0pel8gr1em22csg.jpg'
        ],
        'next_follow_at': '09月02日 13:48',
        'plate_number': '粤S366666',
        'arrive_time': '2020-08-31'
      },
      {
        'note_type': 1,
        'note': '我是一个笔记，写的还可以的笔记',
        'creator_name': '张三',
        'created_at': '2020-08-31',
        'id': 8,
        'images': [
          'https://dpu-test.lxusercontent.com/park/device/images/10199/btlef0pel8gr1em22csg.jpg',
          'https://dpu-test.lxusercontent.com/park/device/images/10199/btlef0pel8gr1em22csg.jpg',
          'https://dpu-test.lxusercontent.com/park/device/images/10199/btlef0pel8gr1em22csg.jpg'
        ],
        'next_follow_at': '09月02日 13:48',
        'plate_number': '粤S366666',
        'arrive_time': '2020-08-31'
      },
      {
        'note_type': 1,
        'note': '我是一个笔记，写的还可以的笔记',
        'creator_name': '张三',
        'created_at': '2020-08-31',
        'id': 9,
        'images': [

        ],
        'next_follow_at': '09月02日 13:48',
        'plate_number': '粤S366666',
        'arrive_time': '2020-08-31'
      },
      {
        'note_type': 1,
        'note': '我是一个笔记，写的还可以的笔记',
        'creator_name': '张三',
        'created_at': '2020-08-31',
        'id': 10,
        'images': [

        ],
        'next_follow_at': '09月02日 13:48',
        'plate_number': '粤S366666',
        'arrive_time': '2020-08-31'
      }
    ],
    'total_count': 50,
    'latest_next_follow_at': '09月02日 13:48'
  },
  'message': 'veniam'
})
